export const DEST_TYPE_COMP = 'DEST_TYPE_COMP';
